import { Loader2, CalendarDays } from "lucide-react";

// Reusable availability slot picker (date select + time-slot buttons).
export function BookingSlots({ availability, loading, date, time, onDate, onTime, hint, testidPrefix = "booking" }) {
  if (loading) {
    return (
      <div className="h-24 flex items-center justify-center">
        <Loader2 className="animate-spin text-[#EF9F27]" />
      </div>
    );
  }
  if (!availability || availability.length === 0) {
    return (
      <p className="mt-4 text-sm text-[#A1A1AA] bg-[#111111] border border-[#333333] rounded-xl p-4">
        No open slots in the next few weeks. Please check back soon.
      </p>
    );
  }
  const slots = availability.find((a) => a.date === date)?.slots || [];
  return (
    <>
      <p className="mt-4 text-xs text-[#A1A1AA] inline-flex items-center gap-1.5">
        <CalendarDays size={13} className="text-[#EF9F27]" /> {hint || "Showing open slots"}
      </p>
      <label className="block text-sm font-medium text-[#A1A1AA] mt-3 mb-1.5">Available date</label>
      <select
        data-testid={`${testidPrefix}-date-input`}
        value={date}
        onChange={(e) => {
          onDate(e.target.value);
          onTime("");
        }}
        className="w-full bg-[#111111] border border-[#333333] rounded-xl px-4 py-3.5 min-h-[44px] text-[#F8FAFC] focus:outline-none focus:border-[#EF9F27]"
      >
        <option value="">Choose a date</option>
        {availability.map((a) => (
          <option key={a.date} value={a.date}>
            {new Date(a.date + "T00:00:00").toLocaleDateString(undefined, {
              weekday: "short", day: "numeric", month: "short",
            })}
          </option>
        ))}
      </select>

      {date && (
        <>
          <label className="block text-sm font-medium text-[#A1A1AA] mt-3 mb-1.5">Available time</label>
          <div className="grid grid-cols-4 gap-2" data-testid={`${testidPrefix}-time-slots`}>
            {slots.map((t) => (
              <button
                key={t}
                data-testid={`${testidPrefix}-slot-${t}`}
                onClick={() => onTime(t)}
                className={`min-h-[44px] rounded-xl text-sm font-bold border transition-colors ${
                  time === t
                    ? "bg-[#EF9F27] text-[#111111] border-[#EF9F27]"
                    : "bg-[#111111] text-[#F8FAFC] border-[#333333] hover:border-[#EF9F27]"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </>
      )}
    </>
  );
}

export function slotRequired(availability, date, time) {
  const slots = (availability.find((a) => a.date === date)?.slots) || [];
  return slots.length > 0 && !time;
}
